import React from 'react'

const BoolResult = (data) => {
  if (data.data == false)
    return 'Not accepted'
  return 'Accepted'
}

export {BoolResult}
